import { render, staticRenderFns } from "./lawFirmAuthentication.vue?vue&type=template&id=a9980226&scoped=true"
import script from "./lawFirmAuthentication.vue?vue&type=script&lang=js"
export * from "./lawFirmAuthentication.vue?vue&type=script&lang=js"
import style0 from "./lawFirmAuthentication.vue?vue&type=style&index=0&id=a9980226&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9980226",
  null
  
)

export default component.exports